import { format } from "date-fns";

export const checkVoid = (data: any) =>
    data === undefined || data === "" || data === null;


export function formatDate(dateStr: string | Date | undefined) {
  const dateFormat = "yyyy-MM-dd";
  if (!dateStr) {
    dateStr = new Date();
  }
  if (typeof dateStr === "string") {
    return format(new Date(dateStr), dateFormat);
  } else {
    return format(dateStr, dateFormat);
  }
}

export function formatDisplayDate(dateStr: string | Date | undefined) {
  if (checkVoid(dateStr)) return "-";
  const dateFormat = "dd MMM yyyy";
  if (!dateStr) {
    dateStr = "-";
  }
  if (typeof dateStr === "string") {
    return format(new Date(dateStr), dateFormat);
  } else {
    return format(dateStr, dateFormat);
  }
}
